$(function () {
  const splashRetention = "//cosette.com.au/cdn/shop/t/88/assets/404-splash.jpg?v=132507514936571723191768863302";
  const splash404 = "//cosette.com.au/cdn/shop/t/88/assets/404-splash-not-found.jpg?v=116986826373260089781768863302";

  if (
    (sessionStorage.getItem("404-splash") &&
      window.location.pathname === "/collections/designers") ||
    window.location.search.includes("auto_retention_abandoned-cart")
  ) {
    let imageUrl;

    if (window.location.search.includes("auto_retention_abandoned-cart")) {
      imageUrl = splashRetention;
    } else {
      imageUrl = splash404;
    }

    $(".algolia-collection-grid").prepend(`
      <div id="not-available-banner" class="content-indent" style="margin-bottom: 25px">
        <div class="row tt-layout-promo-box">
          <div style="font-weight:300;font-size:13px;width:100%;">
            <div style="text-align: left;">
              <img src="${imageUrl}" width="2160" height="1048" style="float: none;" loading="lazy">
            </div>
          </div>
        </div>
      </div>`);

    $(window).scroll(function () {
      var windowScrollDownValue = $(window).scrollTop();
      if (windowScrollDownValue > 760) {
        $("#not-available-banner").remove();
        sessionStorage.removeItem("404-splash");
      }
    });

    sessionStorage.removeItem("404-splash");
  }
});
